import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { useKeycloak } from "../../KeycloakProvider";
import { isOrgAdmin, isExternalKeycloak } from "../../auth/rbac";
import { useModules } from "../../ModuleContext";
import OrgUsersTab from "../settings/OrgUsersTab";
import ModuleSettings from "../settings/ModuleSettings";
import SchedulingTab from "../settings/SchedulingTab";
import MispKeyTab from "../settings/MispKeyTab";

const SettingsPage = () => {
  const { keycloak } = useKeycloak();
  const { modules } = useModules();
  const [tab, setTab] = useState(0);

  const orgAdmin = isOrgAdmin(keycloak);
  const showScheduling = modules.cti_gathering || modules.correlations;

  const tabs = [{ label: "Modules" }];
  if (showScheduling) tabs.push({ label: "Scheduling" });
  if (orgAdmin) tabs.push({ label: "MISP Integration" });
  if (orgAdmin && !isExternalKeycloak()) tabs.push({ label: "Users / Invitations" });

  const safeTab = Math.min(tab, tabs.length - 1);

  const renderTab = () => {
    const label = tabs[safeTab]?.label;
    if (label === "Modules") return <ModuleSettings />;
    if (label === "Scheduling") return <SchedulingTab />;
    if (label === "MISP Integration") return <MispKeyTab />;
    if (label === "Users / Invitations") return <OrgUsersTab />;
    return null;
  };

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ mb: 0.5 }}>
          Settings
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Configure platform modules, scheduling, integrations and team access
        </Typography>
      </Box>

      <Tabs
        value={safeTab}
        onChange={(_, v) => setTab(v)}
        textColor="secondary"
        indicatorColor="secondary"
        sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}
      >
        {tabs.map((t, i) => (
          <Tab key={i} label={t.label} />
        ))}
      </Tabs>

      {renderTab()}
    </Box>
  );
};

export default SettingsPage;
